import  { useEffect, useState } from "react";
import AllInterviewList from "../../components/ThinksToDo/AllInterviewList";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import PendingApprovalList from "../../components/ThinksToDo/PendingApprovalList";
import { CommonHeader } from "../../components/commons";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
interface TabsType {
  name: string;
  label: string;
  display: boolean;
}

let tabs: TabsType[] = [
  {
    name: "All Interviews",
    label: "All Interviews",
    display: false,
  },
  {
    name: "Approval Pending",
    label: "Approval Pending",
    display: false,
  },
];
type AppProps = {
  history: any;
};
const InterviewAndApprovalPendingList = ({ history }: AppProps) => {
  const [finalTab, setFinalTab] = useState(tabs);
  const redirectTab =
    history?.location?.state?.length > 0 ? history?.location?.state : "";
  const [activeTab, setActiveTab] = useState(
    redirectTab ? redirectTab : tabs[0].label
  );
  const [
    isScheduledUpcomingInterviewsPresent,
    setIsScheduledUpcomingInterviewsPresent,
  ] = useMenuCheck("Upcoming Interviews");
  const [
    isPendingInterviewApprovalsPresent,
    setIsPendingInterviewApprovalsPresent,
  ] = useMenuCheck("Interview Approvals");

  useEffect(() => {
    setIsPendingInterviewApprovalsPresent(
      "Pending Things to Do Interview Approvals",
      "menu"
    );
    setIsScheduledUpcomingInterviewsPresent(
      "Scheduled Upcoming Interviews",
      "menu"
    );
  }, []);

  useEffect(() => {
    if (
      isScheduledUpcomingInterviewsPresent &&
      !isPendingInterviewApprovalsPresent
    ) {
      setFinalTab([tabs[0]]);
      setActiveTab(tabs[0]?.label);
    } else if (
      !isScheduledUpcomingInterviewsPresent &&
      isPendingInterviewApprovalsPresent
    ) {
      setFinalTab([tabs[1]]);
      setActiveTab(tabs[1]?.label);
    } else if (
      !isScheduledUpcomingInterviewsPresent &&
      !isPendingInterviewApprovalsPresent
    ) {
      setFinalTab([]);
    } else {
      setFinalTab([...tabs]);
    }
    // setActiveTab(isGetRecruitmentTrackerPresent?tabs[0].label:tabs[1].label)
  }, [
    isScheduledUpcomingInterviewsPresent,
    isPendingInterviewApprovalsPresent,
  ]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const finalTabs = finalTab?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className={tab.display ? "tab-style mr-4 pointer" : "pointer"}
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 16px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "16px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTabs;
  };

  let component;

  if (activeTab === "All Interviews") {
    component = <AllInterviewList history={history} />;
  } else if (activeTab === "Approval Pending") {
    component = <PendingApprovalList history={history} />;
  } else {
    component = <AllInterviewList history={history} />;
  }
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title={`All Interview`} />
      </div>
      <div className="col-md-12">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px 0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div className="new-table-card" style={{ borderRadius: "0 0 4px 4px" }}>
          {component}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: any) => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InterviewAndApprovalPendingList);
